import React, {useEffect, useRef, useState} from "react";
import {Container, Row, Col, Table, Alert, Tabs, Tab, FormLabel, FormGroup} from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "components/Card/Card.jsx";
import PageLoader from "components/Loader/PageLoader.jsx";
import * as fb from "../../firebase";
import Button from "../../components/CustomButton/CustomButton";

const ProductGroupList = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [classes, setClasses] = useState([])
  const [prices, setPrices] = useState({})
  const [productGroups, setProductGroups] = useState([])
  const [errors, setErrors] = useState({})
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")

  const [tab, setTab] = useState('')

  const isMountedRef = useRef(false);
  const successTimeoutRef = useRef(null);

  useEffect(() => {
    isMountedRef.current = true;
    fetchClasses()
    fetchPrices()

    return () => {
      isMountedRef.current = false;
      if (successTimeoutRef.current) {
        clearTimeout(successTimeoutRef.current);
      }
    }
  }, []);

  useEffect(() => {
    fetchData()

    return () => {

    }
  }, [tab]);

  const fetchClasses = async () => {
    try {
      if (isMountedRef.current) setIsLoading(true)
      const settingsDoc = await fb.metaCollection.doc('settings').get();
      const settings = settingsDoc.exists ? settingsDoc.data() : null

      if(settings && settings.hasOwnProperty('shopify_groups')){
        if (isMountedRef.current) {
          setClasses(settings.shopify_groups.sort((a,b) => a.order - b.order))
          setTab(0)
        }
      }else{
        if (isMountedRef.current) setClasses([])
      }
    }catch(err){
      if (isMountedRef.current) setError('fetchClasses '+err.message)
    } finally {
      if (isMountedRef.current) setIsLoading(false)
    }
  }

  const fetchPrices = async () => {
    try {
      const doc = await fb.metaCollection.doc(`PartnersPrices`).get()
      if(doc.exists && isMountedRef.current){
        setPrices(doc.data())
      }
    } catch (err) {
      if (isMountedRef.current) setError('fetchPrices '+err.message)
    }
  }

  const fetchData = async () => {
    if(classes[tab]){
      try {
        if (isMountedRef.current) setIsLoading(true)
        const doc = await fb.metaCollection.doc(`shopify_${classes[tab].ref === 'rb' ? '' : `${classes[tab].ref}_`}products`).get()
        if(doc.exists && doc.data().hasOwnProperty('ids')){
          let productsArr = []

          doc.data().ids.forEach((p,i) => {
            productsArr.push({
              id: '',
              name: '',
              order: '',
              pIndex: i,
              ...p,
            })
          })

          if (isMountedRef.current) setProductGroups(productsArr)
        }else{
          if (isMountedRef.current) setProductGroups([])
        }
      }catch(err){
        if (isMountedRef.current) setError('fetchData '+err.message)
      } finally {
        if (isMountedRef.current) setIsLoading(false)
      }
    }
  }

  const deleteGroup = async (pIndex) => {
    if (window.confirm("Do you want to delete the item?")) {
      const docRef = fb.metaCollection.doc(`shopify_${classes[tab].ref === 'rb' ? '' : `${classes[tab].ref}_`}products`)
      docRef.get().then(async (doc) => {
        if(doc.exists){
          let ids = doc.data().ids
          ids.splice(pIndex, 1);
          await docRef.update({ ids });
        }
        fetchData();
      }).catch(function (error) {
        if (isMountedRef.current) setError('deleteGroup '+error.message)
      });
    }
  }

  const orderOptions = () => {
    let out = []
    for (let i = 0; i < 100; i++) {
      out.push(<option key={i} value={i+1}>{i+1}</option>)
    }
    return out
  }

  const changeClass = (e,field) => {
    let cs = [...classes]
    cs[tab][field] = e.target.value
    setClasses([...cs])
  }

  const changePrice = (e,field) => {
    let p = {...prices}
    p[field] = parseInt(e.target.value*100)
    setPrices({...p})
  }

  const saveClass = () => {
    fb.metaCollection.doc('settings').update({shopify_groups: classes})
    fb.metaCollection.doc(`PartnersPrices`).update(prices)
    setSuccess('Class saved successfully')
    if (successTimeoutRef.current) clearTimeout(successTimeoutRef.current)
    successTimeoutRef.current = setTimeout(()=>{
      if (isMountedRef.current) setSuccess('')
    },3000)
  }

  const deleteClass = async () => {
    if (window.confirm('Are you sure, you want to delete this class and all his product groups?')) {
      let cs = [...classes]
      let pp = {...prices}
      let newcs = cs.filter(item => item.ref !== classes[tab].ref)
      await fb.metaCollection.doc('settings').update({shopify_groups: newcs})
      await fb.metaCollection.doc(`shopify_${cs[tab].ref}_products`).delete()

      const regex = new RegExp(`^${classes[tab].ref}[A-Z]`);
      Object.keys(pp).forEach(key => {
        if (regex.test(key)) delete pp[key];
      });
      await fb.metaCollection.doc(`PartnersPrices`).set(pp)

      await fetchClasses()
      await fetchPrices()
    }
  }

  return (
    <div className="content">
      <Container fluid>
        <Row>
          <Col md={12}>
            {error &&
              <Alert bsStyle="danger">
                <span>{error}</span>
              </Alert>
            }
            {success &&
              <Alert bsStyle="success">
                <span>{success}</span>
              </Alert>
            }
            <Card
              title=""
              category="All Product groups List"
              ctTableFullWidth
              ctTableResponsive
              button={
                <Link to={`product_groups/add`} className="btn btn-success custom-btn pull-right btn-right libi-admin-btn"> Add Product group</Link>
              }
              loader={ isLoading && <PageLoader />}
              content={<>
                <Tabs activeKey={tab}
                      onSelect={(k) => setTab(k)}
                      id="controlled-tab-example">
                  {classes.map((c,i) => <Tab eventKey={i} title={c.ref} key={i}></Tab>)}
                </Tabs>
                <Row className="mb-3">
                  <Col md={6}>
                    <FormGroup>
                      <FormLabel>Title</FormLabel>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Title"
                        name="name"
                        value= {classes[tab]?.title || ''}
                        onChange={(e) =>  changeClass(e,'title')}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={2}>
                    <FormGroup>
                      <FormLabel>Order</FormLabel>
                      <select
                        className= "form-control"
                        name= "order"
                        value={classes[tab]?.order || ''}
                        onChange={(e) =>  changeClass(e,'order')}
                      >
                        <option value="">Select Order</option>
                        {orderOptions()}
                      </select>
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={4}>
                    <FormGroup>
                      <FormLabel>Price UK</FormLabel>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="0.00"
                        name="uk"
                        value= {prices[`${classes[tab]?.ref}PricePartner0UK`]/100 || ''}
                        onChange={(e) =>  changePrice(e,`${classes[tab].ref}PricePartner0UK`)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormLabel>Price HU</FormLabel>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="0.00"
                        name="hu"
                        value= {prices[`${classes[tab]?.ref}PricePartner0HU`]/100 || ''}
                        onChange={(e) =>  changePrice(e,`${classes[tab].ref}PricePartner0HU`)}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={6} md={2}>
                    <FormGroup>
                      <FormLabel></FormLabel>
                      <Button
                        className="btn-fill pull-right libi-admin-btn"
                        bsStyle="info"
                        type="button"
                        onClick={saveClass}
                      >
                        {'Save'}
                      </Button>
                    </FormGroup>
                  </Col>
                  <Col xs={6} md={2}>
                    <FormGroup>
                      <FormLabel></FormLabel>
                      <Button
                        className="btn-fill pull-right libi-admin-btn"
                        bsStyle="info"
                        type="button"
                        onClick={deleteClass}
                      >
                        {'Delete'}
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
                <Table
                  striped
                  hover
                  id="list-datatable"
                >
                  <thead>
                  <tr>
                    <th>Order</th>
                    <th>Title</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  {productGroups.map((group, i) => (
                    <tr key={`${group.pIndex}-${i}`}>
                      <td>{group.order}</td>
                      <td>{group.name}</td>
                      <td>
                        <a href={`product_groups/edit/${classes[tab]?.ref}/${group.pIndex}`}><i className="fa fa-edit" /></a>&nbsp;&nbsp;
                        <a href="#" onClick={(e) => {
                          e.preventDefault();
                          deleteGroup(group.pIndex);
                        }}><i className="fa fa-times" /></a>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </Table>
              </>}
            />
          </Col>
        </Row>
      </Container>
    </div>
  )

}

export default ProductGroupList;
